import React from 'react'
import { result } from 'libraries/lodash'
import Grid from '@material-ui/core/Grid'
import NotFound from 'components/NotFound'
import useObservable from 'front-end-core/hooks/useObservable'
import { getAutomatedListingTree } from 'services/PrecedentsService'
import Error from 'components/shared/Error'
import Section from './Section'

const Main = ({ sectionId, aol, focusedId }) => {
  if (!sectionId) {
    return <NotFound />
  }

  const { sections = {}, childSections = [], documents = {} } = useObservable(getAutomatedListingTree({ aol, sectionId }))

  const sectionTitle = result(sections, ['nodes', sectionId, 'title'], '')

  const childSectionObjs = childSections.map(id => ({ ...sections.nodes[id], documents })).filter(section => section.active)

  return (
    <div>
      <div className='bg-ghost-grey'>
        <div className='layout-width-constraint'>
          <div className='bg-white mb12'>
            <div className='bb-thick b--precedents-blue'>
              <Grid container justify='space-between' className='pt7 pb6'>
                <Grid item className='b f3 pl6'>
                  {sectionTitle}
                </Grid>
              </Grid>
              {childSections.length === 0 && <Error title='No Content' />}
              <ul className='list-reset ml0 mv0 pa0'>
                {childSectionObjs.map(section => <Section startExpanded={focusedId === section.id} key={section.id} {...{ ...section, sectionTitle, sectionId, documents }} />)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Main
